/*
═══════════════════════════════════════════════════════════
НАСТРОЙКА НА ЯСНОСТЬ / CLARITY
═══════════════════════════════════════════════════════════
Автор: @Elena_evolvecode
Telegram: @na_sh_kodila
Создано: 2025-2026
Все права защищены
═══════════════════════════════════════════════════════════
*/

import React from 'react';

const InjectionCard = ({ tuning, isRead, onRead }) => {
  return (
    <div
      style={{
        ...styles.card,
        borderColor: isRead ? 'rgba(229, 210, 160, 0.5)' : 'rgba(229, 210, 160, 0.3)',
      }}
    >
      <div style={styles.header}>
        <span style={styles.icon}>◈</span>
        <span style={styles.label}>Настройка дня</span>
        {isRead && <span style={styles.checkmark}>✓</span>}
      </div>

      <p style={styles.text}>{tuning}</p>

      {!isRead && (
        <button style={styles.button} onClick={onRead}>
          ПРИНЯТЬ НАСТРОЙКУ
        </button>
      )}
    </div>
  );
};

const styles = {
  card: {
    background: 'linear-gradient(135deg, rgba(229, 210, 160, 0.1) 0%, rgba(229, 210, 160, 0.05) 100%)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
  },
  icon: {
    color: '#E5D2A0',
    fontSize: '16px',
  },
  label: {
    color: '#E5D2A0',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    flex: 1,
  },
  checkmark: {
    color: '#E5D2A0',
    fontSize: '16px',
  },
  text: {
    color: 'rgba(255, 255, 255, 0.85)',
    fontSize: '15px',
    lineHeight: '1.7',
    margin: '0 0 16px 0',
  },
  button: {
    width: '100%',
    padding: '14px',
    background: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#E5D2A0',
    borderRadius: '12px',
    color: '#E5D2A0',
    fontSize: '13px',
    fontWeight: '600',
    letterSpacing: '2px',
    cursor: 'pointer',
  },
};

export default InjectionCard;
